import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-calendarday',
  templateUrl: './calendarday.component.html',
  styleUrls: ['./calendarday.component.scss']
})
export class CalendardayComponent {
  @Output() newItemEvent = new EventEmitter<string>();
  @Input() date: any;
  @Input() selecteddate: any;

  today = new Date().getDate();
  year = new Date().getFullYear();
  month = new Date().getMonth();
  isSelected: boolean = false;
  dateclicked:boolean=false;
  ngOnInit() {
  }
  selectedDate(date: any) {
    this.dateclicked=true;
    this.isSelected = !this.isSelected;
    this.newItemEvent.emit(date);

  }
}
